import React from "react";

const ExclamationMark: React.FC = () => (
  <svg width="10" height="10" viewBox="0 0 2 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.68629 7.27718H0.266457L0.110207 0.687469H1.84934L1.68629 7.27718ZM0.0626526 10.3801C0.0626526 10.1054 0.146439 9.87894 0.314011 9.70065C0.481584 9.51754 0.710297 9.42599 1.00015 9.42599C1.29001 9.42599 1.51872 9.51754 1.68629 9.70065C1.85387 9.87894 1.93765 10.1054 1.93765 10.3801C1.93765 10.6451 1.85613 10.8667 1.69309 11.045C1.53004 11.2233 1.29907 11.3125 1.00015 11.3125C0.70124 11.3125 0.470261 11.2233 0.307218 11.045C0.144174 10.8667 0.0626526 10.6451 0.0626526 10.3801Z"
      fill="white"
    />
  </svg>
);

export default ExclamationMark;
